// extracted by mini-css-extract-plugin
export var textInput = "_i3-0";